/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import React from "react";
import PropTypes from "prop-types";
import Input from "../common/Input";
import {calculateDisplayedErrors} from "../common/Helpers";
import { useTranslation } from 'react-i18next';

function TeacherForm({firstName, lastName, email, mobile, touched, errors, onBlur, onChange, onSubmit, status, readOnly}) {
  const { t: tr } = useTranslation();
  const err = calculateDisplayedErrors(errors, touched, status);
  return (
    <div>
      <h2 className="manage-title">{tr("manage:teacher_226")}</h2>
      <form id="teacher-form" onSubmit={onSubmit}>
        <div className="form-row">
          <div className="col-md-12 mb-1  ">
            <Input readOnly={readOnly} label={tr("common:firstName")} onBlur={onBlur} onChange={onChange} name="firstName" value={firstName} error={err.firstName} placeholder={tr("common:firstName")} />
            <Input readOnly={readOnly} label={tr("common:lastName")} onBlur={onBlur} onChange={onChange} name="lastName" value={lastName} error={err.lastName} placeholder={tr("common:lastName")} />
            <Input readOnly={readOnly} label={tr("manage:emailOptional_109")} onBlur={onBlur} onChange={onChange} name="email" value={email || ''} error={err.email} placeholder={tr("common:email")} />
            <Input readOnly={readOnly} label={tr("manage:phoneOptional_110")} onBlur={onBlur} onChange={onChange} name="mobile" value={mobile || ''} error={err.mobile} placeholder={tr("manage:phoneNumber_111")} />
          </div>
        </div>
      </form>

    </div>
  );
}

TeacherForm.propTypes = {
  readOnly: PropTypes.bool,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  mobile: PropTypes.string,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
};

TeacherForm.defaultProps = {
  readOnly: false,
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
};

export default TeacherForm;
